import React, { useEffect } from 'react'
import { withAuth } from '../AuthContext'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'

const CommunitySection = styled.section`
  margin: 0;
`

const Community2 = () => {
  const [landingPage, setLandingPage] = React.useState('')

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const landingPage = queryParams.get('lp')

    if (landingPage) {
      if (landingPage.includes('user-')) {
        setLandingPage(
          `https://community.freebirdclub.com/u/${landingPage.replace(
            'user-',
            ''
          )}?automatic_login=true`
        )
      } else {
        setLandingPage(
          `https://community.freebirdclub.com/c/${landingPage}/?automatic_login=true`
        )
      }
    } else {
      setLandingPage('https://community.freebirdclub.com?automatic_login=true')
    }
  }, [])

  return (
    <CommunitySection className="edit-profile">
      <iframe src={landingPage} className="communityFrame2"></iframe>
    </CommunitySection>
  )
}

export default withRouter(withAuth(Community2))
